module.exports = __webpack_public_path__ + "static/media/loading.612e439e.svg";